import { create } from 'zustand'

export const useAidaSessionEpochStore = create(() => ({
  epoch: 0,
}))

export function bumpAidaSessionEpoch() {
  useAidaSessionEpochStore.setState(state => ({ epoch: state.epoch + 1 }))
}
